/**
 * @desc 软删除(弃用)，前端去除对应功能
 */
const URL = "/rantion-ucenter";
import http, { updateResponse } from "@/http";
export function request(id: string | number, options?: any) {
  return updateResponse(
    http(URL + `/organization/${id}`, {
      method: "DELETE",

      ...options,
    }),
  );
}
